import React, { Component } from "react";
import { Popover, PopoverHeader, PopoverBody, Input } from "reactstrap";

import { connect } from "react-redux";
import actions from "../../redux/groceryList/action";
import GroceryProduct from "./GroceryProduct";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { serverResponse } from "../../util/fakeServer";
import { isMobile } from "react-device-detect";
import RemoveAllBtn from "./RemoveAllBtn";
import { defaultLanguage, getCustomActions } from "../../helper/utility";
import { groceryListSentFlag } from "../../helper/constant";
import { language } from "../../languageProvider/language/language";
import ManagerFactory from "../../managers/ManagerFactory";
import SaveIcon from "../../assets/icons/save.icon";
import { CartIcon } from "../../assets/icons";
import CloseCartIcon from "../../assets/icons/closeCart.icon";
import WhatsappCartIcon from "../../assets/icons/whatsapp-icon";
const manager = ManagerFactory.getManager();
class GroceryList extends Component {
  constructor(props) {
    super(props);
    this.addNewProductRef = React.createRef();
  }
  state = {
    newProductTitle: "",
    newProductPrice: "",
    newProductQuantity: 1,
    saveTooltipOpen: false,
    deleteAllTooltipOpen: false,
  };

  handleChangeTitle = (e) => {
    this.setState({ newProductTitle: e.target.value });
  };

  handleChangePrice = (e) => {
    this.setState({ newProductPrice: e.target.value });
  };

  handleKeyUp = (event) => {
    var keycode = event.which;
    if (
      !(
        event.shiftKey === false &&
        (keycode === 46 ||
          keycode === 8 ||
          keycode === 37 ||
          keycode === 39 ||
          (keycode >= 48 && keycode <= 57))
      )
    ) {
      event.preventDefault();
    }
  };

  handleChangeQuantity = (type) => {
    let newQuantity;
    if (type === 1) {
      // increment
      newQuantity = this.state.newProductQuantity + 1;
    } else {
      //decrement
      if (this.state.newProductQuantity > 1) {
        newQuantity = this.state.newProductQuantity - 1;
      } else {
        newQuantity = this.state.newProductQuantity;
      }
    }
    this.setState({ newProductQuantity: newQuantity });
  };

  saveNewProduct = () => {
    let { newProductTitle, newProductPrice, newProductQuantity } = this.state;

    if (newProductTitle === "" || newProductPrice === 0) return;

    this.props.addProduct({
      item_id: Date.now(),
      description: "",
      field1: newProductTitle,
      filed2: "",
      filed3: "",
      filed4: "",
      grocery_label: "pz.",
      images: [
        {
          image_file: "",
          cropped: false,
        },
      ],
      price: Math.abs(newProductPrice),
      price_label: "€" + newProductPrice,
      quantity: newProductQuantity,
      equivalence: 1,
      quantity_step: 1,
      done: 0,
      variety: undefined,
      offer_price: null,
      prices: null,
      promo: null,
      sku: null,
      skul: "",
    });

    this.setState({
      newProductTitle: "",
      newProductPrice: "",
      newProductQuantity: 1,
    });
  };

  toggleSaveTooltip = () => {
    this.setState({ saveTooltipOpen: !this.state.saveTooltipOpen });
  };

  toggleDeleteAllTooltip = () => {
    this.setState({ deleteAllTooltipOpen: !this.state.deleteAllTooltipOpen });
  };

  showCustomProductOnMobile = () => {
    if (isMobile) {
      document.getElementById("prodottoNonPresente").style.display = "block";
    }
  };

  hideCustomProductOnMobile = () => {
    if (isMobile) {
      document.getElementById("prodottoNonPresente").style.display = "none";
    }
  };

  stopPropagation = (event) => {
    event.stopPropagation();
  };

  sendGroceryListToMarket = (getLink = false) => {
    var tmpProducts = this.props.groceryList.list;

    tmpProducts.forEach((element) => {
      element.image_file = element.images[0]
        ? element.images[0].image_file
        : "";
    });

    var idParam = Math.random().toString(36).substr(2, 16);
    var product = this.props.groceryList.list;
    for (var i = 0; i < product.length; i++) {
      product[i].description = product[i].description
        ? product[i].description.substring(0, 80)
        : product[i].field1.substring(0, 80);
      product[i].field1 = product[i].field1.substring(0, 80);
      product[i].field2 = product[i].field2
        ? product[i].field2.substring(0, 80)
        : "";
      product[i].field3 = product[i].field3
        ? product[i].field3.substring(0, 80)
        : "";
      product[i].field4 = product[i].field4
        ? product[i].field4.substring(0, 80)
        : "";
    }

    var exportObj = {
      id_param_url: idParam,
      id_campagna: this.props.groceryList.idCampaign,
      flyer_url:
        window.location.host === "preview.interattivo.net"
          ? "preview"
          : `${process.env.REACT_APP_VIEW}/${serverResponse.config.client_code}/${serverResponse.config.slug}`,
      // "prodotti": this.props.groceryList.list
      prodotti: product,
      pid: this.props.authJWT.user ? this.props.authJWT.user.id : null,
    };

    if (getLink) {
      getCustomActions().exportList(exportObj);
      const linkShare = getCustomActions().getShareListLink(idParam);
      return linkShare;
    }

    getCustomActions().sendList(exportObj, idParam, true);
  };

  getCompleteOrderType = () => {
    let type = "inshop";

    if (serverResponse.config.send_grocery_list_data)
      type = serverResponse.config.send_grocery_list_data.type;

    return type;
  };

  completeOrder = () => {
    let type = this.getCompleteOrderType();

    // AC1: Salvare il flag PRIMA del reindirizzamento
    const flyerCode = serverResponse.leaflet.code;
    localStorage.setItem(groceryListSentFlag + flyerCode, "true");

    switch (type) {
      case "whatsapp":
        let url = this.sendGroceryListToMarket(true);
        let numero = serverResponse.config.send_grocery_list_data.phone_number;
        window.open(`https://wa.me/${numero}?text=${url}`, "_blank");
        break;
      case "inshop":
        this.sendGroceryListToMarket(false);
        break;
      default:
    }
  };

  render() {
    const { newProductTitle, newProductPrice, newProductQuantity } = this.state;

    const mobile_style = {
      height: "calc(100vh - 125px)",
      width: "100%",
    };

    const desktop_style = {
      backgroundColor: "white",
    };

    var totPrice = 0;
    let list = this.props.groceryList.list.map((product, key) => {
      //totPrice += parseFloat(product.price) * parseInt(product.quantity);
      if (!product.no_price) {
        totPrice += parseFloat(product.currentPrice);
      }

      return (
        <GroceryProduct
          no_price={product.no_price}
          promo={product.promo}
          prices={product.prices}
          key={key}
          id={product.item_id}
          title={product.field1}
          variety={product.variety}
          price={product.currentPrice}
          grocery_label={product.grocery_label}
          quantity={product.quantity}
          quantity_step={product.quantity_step}
          done={product.done}
          images={product.images}
        />
      );
    });

    let grocery_label = serverResponse.config.send_grocery_list_to_market
      ? language[defaultLanguage].il_tuo_carrello
      : language[defaultLanguage].la_tua_lista_della_spesa;

    return (
      <Popover
        className="header-popover-width custom-popover grocery-list-popover"
        isOpen={this.props.isOpen}
        target={this.props.target}
        placement={this.props.placement}
        toggle={this.props.toggle}
        trigger="block"
        boundariesElement="window"
        onClick={this.stopPropagation}
      >
        <PopoverHeader
          className="custom-popover-header text-center m-0"
          title={language[defaultLanguage].condividi_lista}
        >
          <div className="header-left-content">
            <span className="forward-icon">
              {manager.visibilityConditionShareGrocery(
                list.length > 0 &&
                  !serverResponse.config.hide_share_grocery_list
              ) && manager.leftButtonGroceryComponent(this.props.toggle)}
            </span>
          </div>
          <div
            className="title"
            style={{
              marginLeft:
                manager.buttonCloseGrocery() &&
                !serverResponse.config.hide_share_grocery_list
                  ? ""
                  : "",
            }}
          >
            {grocery_label}
          </div>

          <div
            className="header-right-content"
            title={language[defaultLanguage].chiudi}
          >
            {manager.buttonCloseGrocery() && (
              <CloseCartIcon
                color={"#0008"}
                icon={faTimes}
                onClick={this.props.toggle}
              />
            )}
          </div>
        </PopoverHeader>

        <PopoverBody
          id="wrapper-body"
          style={isMobile ? mobile_style : desktop_style}
        >
          <>
            {/* <Scrollbars
              className="custom-scrollbars"
              autoHide
              style={{
                height: isMobile ? "calc(100% - 175px)" : "50vh",
                marginBottom: "200px",
              }}
            > */}
            {list.length > 0 &&
              serverResponse.config.send_grocery_list_to_market &&
              totPrice < serverResponse.config.grocery_list_min_value && (
                <div>
                  <div
                    style={{
                      textAlign: "center",
                      paddingTop: "15px",
                      paddingBottom: "5px",
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign: "center",
                      paddingBottom: "15px",
                      width: "90%",
                      margin: "auto",
                    }}
                  >
                    Raggiungi una spesa minima di{" "}
                    {serverResponse.config.grocery_list_min_value}€ per poter
                    inviare la tua lista
                  </div>
                </div>
              )}
            <div className="cart-card-wrapper">{list}</div>
            {/* </Scrollbars> */}

            {/*Insert by hand*/}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                bottom: "0",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent:
                    list.length > 0 &&
                    serverResponse.config.send_grocery_list_to_market &&
                    totPrice >= serverResponse.config.grocery_list_min_value
                      ? "space-around"
                      : "flex-start",
                  alignItems: "center",
                  backgroundColor: "white",
                }}
              ></div>
              <div className="cart-price-info-wrapper">
                <div className="d-flex align-items-center gap-3">
                  <div className="cart-price">
                    <span className="total-text">
                      {language[defaultLanguage].totale}:
                    </span>
                    <span className="total-price">{totPrice.toFixed(2)} €</span>
                  </div>
                  <RemoveAllBtn
                    active={this.props.groceryList.list.length > 0}
                    deleteAll={() => {
                      this.props.deleteAll();
                      deleteAll(Array.from(this.props.groceryList.list));
                    }}
                  />
                </div>
                {list.length > 0 &&
                  serverResponse.config.send_grocery_list_to_market &&
                  totPrice >= serverResponse.config.grocery_list_min_value && (
                    <div className="order-btn">
                      <button
                        className="btn btn-green"
                        onClick={() => this.completeOrder()}
                      >
                        {
                          language[defaultLanguage][
                            manager.labelCompleteOrder()
                          ]
                        }{" "}
                        {this.getCompleteOrderType() === "inshop" && (
                          <CartIcon className="ml-8" />
                        )}
                        {this.getCompleteOrderType() === "whatsapp" && (
                          <WhatsappCartIcon className="ml-8" />
                        )}
                      </button>
                    </div>
                  )}
              </div>
              {false && !serverResponse.config.hide_plus_product ? (
                <div className="cart-modal-bottom-content d-flex flex-column">
                  <h6>{language[defaultLanguage].aggiungi_non_presente}</h6>
                  <div ref={this.addNewProductRef} className="add-product-form">
                    <div className="d-flex product-input">
                      <div className="form-group product-name">
                        <Input
                          type="text"
                          name="product-title"
                          id="product-title"
                          placeholder={language[defaultLanguage].nome_prodotto}
                          value={newProductTitle}
                          onChange={this.handleChangeTitle}
                        />
                      </div>
                      <div className="grocery-product-quantity">
                        <span className="quantity-icon xs-none">
                          <FontAwesomeIcon
                            icon={faMinus}
                            onClick={() => this.handleChangeQuantity(0)}
                          />
                        </span>
                        <span className="d-flex">
                          <h6>{newProductQuantity}</h6>
                        </span>
                        <span className="quantity-icon xs-none">
                          <FontAwesomeIcon
                            icon={faPlus}
                            onClick={() => this.handleChangeQuantity(1)}
                          />
                        </span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between flex-wrap price-input-wrapper">
                      {!serverResponse.config.hide_plus_product_price ? (
                        <div className="form-group">
                          <Input
                            min={0}
                            type="number"
                            name="product-price"
                            id="product-price"
                            placeholder={
                              language[defaultLanguage].prezzo_stimato
                            }
                            value={newProductPrice}
                            onChange={this.handleChangePrice}
                            onKeyPress={this.handleKeyUp}
                          />
                        </div>
                      ) : null}
                      <div className="save-btn">
                        <button
                          onClick={() => this.saveNewProduct()}
                          className="btn btn-primary-outlined"
                        >
                          aggiungi <SaveIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {!serverResponse.config.hide_plus_product ? (
                <div id="prodottoNonPresente" style={{ background: "white" }}>
                  <div id="closeIcon">
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => this.hideCustomProductOnMobile()}
                    />
                  </div>
                </div>
              ) : null}
            </div>
            {/* fine bottoni */}
          </>
        </PopoverBody>
      </Popover>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    groceryList: state.groceryList,
    authJWT: state.authJWT,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    addProduct: (newProduct) => {
      dispatch(actions.addProduct(newProduct));
    },
    deleteAll: () => {
      dispatch(actions.deleteAll());
    },
  };
}

function deleteAll(items) {
  items.forEach((item) => {
    var image = document.getElementById("selected-" + item.item_id);
    if (image != null) {
      image.style["display"] = "none";
    }
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(GroceryList);
